export default "__VITE_PUBLIC_ASSET__6d58a0ab__"